import React from "react";
import { Button, Typography, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Title } = Typography;

const PageHeader = ({ onCreateOrder }) => {
  return (
    <Space style={{ marginBottom: 24, width: "100%", justifyContent: "space-between" }}>
      <Title level={2} style={{ margin: 0 }}>
        Siparişler
      </Title>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={onCreateOrder}
      >
        Yeni sipariş oluştur
      </Button>
    </Space>
  );
};

export default PageHeader;